import * as styles from './styles';

const Footer: React.FC = () => {
  return (
    <footer css={styles.footerContainer}>
      <div>
        <a
          href="https://goodocteam.notion.site/2023-09-01-369a6e2d2e924e5d9febe76415bca510"
          css={[styles.footer, styles.boldFooter]}
        >
          개인정보처리방침
        </a>
        <a
          href="https://www.notion.so/2022-06-20-4e717d1faa6d44318bdab9aea0f11b81"
          css={styles.footer}
        >
          서비스이용약관
        </a>
      </div>
      <p>All rights reserved ©goodoc</p>
    </footer>
  );
};

export default Footer;
